import { useRef, type ReactNode } from 'react';
import { BreadcrumbFocusContext, type PendingBreadcrumbFocus } from './breadcrumbFocusContextValues';

export function BreadcrumbFocusProvider({ children }: { children: ReactNode }) {
  const pending = useRef<PendingBreadcrumbFocus | null>(null);
  return <BreadcrumbFocusContext.Provider value={pending}>{children}</BreadcrumbFocusContext.Provider>;
}
